import { useState } from "react";

export default function RentAffordability() {
  const [income, setIncome] = useState(0);
  const [expenses, setExpenses] = useState(0);

  const gross = Number(income) || 0;
  const otherExpenses = Number(expenses) || 0;
  const maxConservative = gross * 0.25;
  const maxStandard = gross * 0.3;
  const maxStretch = gross * 0.35;
  const adjustedMaxRent = Math.max(0, maxStandard - otherExpenses);

  const dti = gross ? (maxStandard + otherExpenses) / gross : 0;
  const rentBand = adjustedMaxRent >= 1800 ? "affordable" : adjustedMaxRent >= 1200 ? "stretched" : "difficult";
  const rentColor = adjustedMaxRent >= 1800 ? "var(--emerald)" : adjustedMaxRent >= 1200 ? "var(--gold, #B7791F)" : "var(--rust)";

  return (
    <main style={{ padding: "120px 0 80px" }}>
      <div className="container">
        <h1 style={{ fontFamily: "Fraunces, serif", fontSize: 40, marginBottom: 8 }}>Rent Affordability</h1>
        <p style={{ color: "var(--t2)", marginBottom: 20 }}>The standard rule of thumb: your rent shouldn't exceed 30% of your gross monthly income. But your real budget depends on your other fixed expenses too — use this to find your number.</p>

        <div className="card-base" style={{ padding: 20, marginBottom: 18 }}>
          <label style={{ display: "block", marginBottom: 10 }}>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>Monthly income (before tax)</div>
            <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Use your gross monthly pay — what you earn before taxes come out.</div>
            <input type="number" className="input" value={income} onChange={(e) => setIncome(e.target.value)} placeholder="e.g. 4500" />
          </label>

          <label style={{ display: "block", marginTop: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>Other fixed monthly expenses ($)</div>
            <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Add up your car payment, subscriptions, loan minimums, etc.</div>
            <input type="number" className="input" value={expenses} onChange={(e) => setExpenses(e.target.value)} placeholder="e.g. 250" />
          </label>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 12 }}>
          <div className="card-base" style={{ padding: 18 }}>
            <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 8 }}>30% rule max rent</div>
            <div style={{ fontSize: 24, fontFamily: "Fraunces, serif" }}>${maxStandard.toFixed(0)}</div>
          </div>
          <div className="card-base" style={{ padding: 18 }}>
            <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 8 }}>Your adjusted max rent</div>
            <div style={{ fontSize: 24, fontFamily: "Fraunces, serif", color: rentColor }}>${adjustedMaxRent.toFixed(0)}</div>
          </div>
        </div>

        <div className="card-base" style={{ marginTop: 14, padding: 14, background: "var(--emerald-soft)" }}>
          In 2026, the median 1-bedroom rent in major US cities is around $1,500–$2,200. Based on your income, you're looking at the <strong>{rentBand}</strong> range of the market.
        </div>

        {gross > 0 && (
          <div style={{ marginTop: 12 }}>
            {dti > 0.36 ? (
              <div className="card-base" style={{ padding: 14, background: "var(--bg-warm)", color: "var(--rust)" }}>
                With your other fixed expenses, this rent level would push your housing burden beyond what many lenders consider comfortable.
              </div>
            ) : (
              <div style={{ color: "var(--t3)", marginTop: 6 }}>This keeps your housing costs within a more realistic budget once your other bills are accounted for.</div>
            )}
          </div>
        )}
      </div>
    </main>
  );
}
